module.exports = __webpack_public_path__ + "media/V31.1bb0ed28.mp4";